<script setup>
import BaseDialogDelete from '@/components/base/BaseDialogDelete.vue';

const open = defineModel('open');
const roleName = defineModel('roleName');
</script>

<template>
    <BaseDialogDelete
        v-model:open="open"
        title="確認刪除此角色"
        :content="`確定要刪除 <span class='text-red-500 font-bold'>${roleName}</span> 此角色嗎？此操作無法復原。`"
        ok-text="確認刪除"
        cancel-text="取消"
    />
</template>
